import { Model } from '@vuex-orm/core'

export default class Station extends Model {
  static entity = 'stations'

  static primaryKey = 'crs_code'

  static fields() {
    return {
      name: this.attr(''),
      name_code: this.attr(''),
      crs_code: this.attr(''),
      category: this.attr(''),
      station_notifications: this.attr([]),
    }
  }
}
